import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Sidebar from "@Components/Sidebar";
import { useMediaQuery } from "react-responsive";
import Header from "../Components/Header";
import LidarTelemetryLiveBridge from "../Components/Telemetry/LidarTelemetryLiveBridge";

const UserLayout = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const [isMobileTablet, setIsMobileTablet] = useState(false);

  // Media query to check if screen is less than 1024px
  const isMobile = useMediaQuery({ query: "(max-width: 1023px)" });

  useEffect(() => {
    if (isMobile) {
      setIsSidebarCollapsed(true);
      setIsMobileTablet(true);
    } else {
      setIsMobileTablet(false); // Expand sidebar when the screen is above 1024px
    }
  }, [isMobile]);

  return (
    <div className="flex min-h-screen bg-primary">
      <LidarTelemetryLiveBridge />
      {/* Sidebar */}
      <Sidebar
        onToggle={(collapsed) => setIsSidebarCollapsed(collapsed)}
        isSidebarCollapsed={isSidebarCollapsed}
        isMobileTablet={isMobileTablet}
      />
      {/* Top header */}
      <Header
        isSidebarCollapsed={isSidebarCollapsed}
        isMobileTablet={isMobileTablet}
        setIsSidebarCollapsed={setIsSidebarCollapsed}
      />

      {/* Right Side Content */}
      <div
        className={`bg-[#F6F6F9] transition-all duration-300 ease-in-out min-w-0 max-w-full overflow-x-hidden ${
          isSidebarCollapsed
            ? "ml-0 w-full lg:ml-[72px] lg:w-[calc(100%_-_72px)]"
            : isMobileTablet
            ? "ml-[0px] w-[calc(100%_-_0px)]"
            : "ml-[240px] w-[calc(100%_-_240px)]"
        }`}
      >
        {React.Children.map(children, (child) =>
          React.cloneElement(child, {
            isSidebarCollapsed,
            isMobileTablet,
            setIsSidebarCollapsed,
          })
        )}
      </div>
    </div>
  );
};

UserLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UserLayout;
